module.exports = __webpack_public_path__ + "static/img/male-6.ed03de8f.png";